export var Url;
(function (Url) {
    Url["Action"] = "/action";
    Url["AgentHandlingTime"] = "/reporting/average-handling-time";
    Url["AgentInformation"] = "/agent-information";
    Url["AgentsOnChat"] = "/agents-on-chat";
    Url["Attachments"] = "/attachments";
    Url["AuthMethods"] = "/auth-methods";
    Url["AutomatableEmail"] = "/automatable-email";
    Url["Bans"] = "/banned-email-addresses";
    Url["BookingDetails"] = "/booking-details";
    Url["Brands"] = "/brands";
    Url["Call"] = "/calls";
    Url["ChangeLanguage"] = "/change-language";
    Url["Chat"] = "/chats";
    Url["ChatTranscript"] = "/transcripts";
    Url["ChatWallboard"] = "/live-chat-reporting/chat-wallboard";
    Url["ChatWidgetAppearances"] = "/chat-widget-appearances";
    Url["Configuration"] = "/chat-configuration";
    Url["Conversations"] = "/conversations";
    Url["CustomerUrls"] = "/customer-urls";
    Url["EmailAccounts"] = "/email-accounts";
    Url["EmailRoutingRules"] = "/email-routing-rules";
    Url["Departments"] = "/departments";
    Url["Emails"] = "/emails";
    Url["EmailsDeferrals"] = "/deferrals";
    Url["EmailsDeferred"] = "/emails/deferred";
    Url["EmailsNext"] = "/emails/next";
    Url["EmailsProposedActions"] = "/proposed-actions";
    Url["ExternalInteractions"] = "/external-interactions";
    Url["Flow"] = "/logic/flow";
    Url["FormFields"] = "/form-fields";
    Url["FormSubmissions"] = "/form-submissions";
    Url["Forms"] = "/forms";
    Url["Intents"] = "/intents";
    Url["Interactions"] = "/interactions";
    Url["InteractionMetricsDistributions"] = "/interaction-metrics/distribution";
    Url["Languages"] = "/languages";
    Url["ManualRoutingEmails"] = "/manual-routing-emails";
    Url["Notes"] = "/notes";
    Url["OfflineDeflection"] = "/offline-deflection";
    Url["OutboundEmailActions"] = "/outbound-email-actions";
    Url["Predictions"] = "/predictions";
    Url["Query"] = "/queries";
    Url["QuerySearch"] = "/email-search";
    Url["ReportAxes"] = "/report-axes";
    Url["ReportFunctions"] = "/report-functions";
    Url["ReportGroups"] = "/report-groups";
    Url["ReportMetrics"] = "/report-metrics";
    Url["ReportingCallWallBoard"] = "/reporting/call-wallboard";
    Url["ReportingCustom"] = "/reporting/custom";
    Url["ReportingHistoric"] = "/reporting-historic";
    Url["ReportingHistoricInteractionsOverTime"] = "/reporting/interactions-over-time";
    Url["ReportingHistoricLanguages"] = "./reporting/interactions-by-language";
    Url["ReportingHistoricUsers"] = "./reporting/interactions-by-user";
    Url["ReportingPublic"] = "/reporting-public";
    Url["ReportingQueue"] = "/reporting-queue";
    Url["Reports"] = "/reports";
    Url["Settings"] = "/settings";
    Url["Setup"] = "/setup";
    Url["Setups"] = "/setups";
    Url["Skills"] = "/skills";
    Url["StartBlocks"] = "/logic/start-blocks";
    Url["SurveyForms"] = "/survey-forms";
    Url["Templates"] = "/text-templates";
    Url["TemplatesUsagesStatistics"] = "/text-templates/usages/statistics";
    Url["TemplatesFeatured"] = "/text-templates/featured";
    Url["TemplatesUsages"] = "/text-templates/:textTemplateId/usages";
    Url["TextLocalisations"] = "/text-localisations";
    Url["TextTemplateGroups"] = "/text-template-groups";
    Url["TextTemplateVariables"] = "/text-template-variables";
    Url["Themes"] = "/themes";
    Url["Topics"] = "/topics";
    Url["Translations"] = "/translations";
    Url["Users"] = "/users";
    Url["ValidateToken"] = "/token";
    Url["ValidateUser"] = "/authenticate";
    Url["Visualisations"] = "/visualisations";
})(Url || (Url = {}));
export default Url;
//# sourceMappingURL=url.js.map